// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickLinksCard_ql__GQZNB {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-primary-3);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
}
.QuickLinksCard_ql__title__WMSzo {
  padding: 0;
  margin: 0;
  font-size: var(--default-font-size);
  font-weight: 700;
  margin-bottom: 3rem;
}
.QuickLinksCard_ql__content__QKbvt {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-sizing: border-box;
  margin: 2rem 0 2rem 0;
}
.QuickLinksCard_ql__content__QKbvt > :not(:last-child) {
  margin-bottom: 2rem;
}
@media only screen and (max-width: 50em) {
  .QuickLinksCard_ql__content__QKbvt > :not(:last-child) {
    margin-bottom: 4rem;
  }
}
.QuickLinksCard_ql__link__Hg6zh {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.QuickLinksCard_ql__link__Hg6zh:hover {
  color: var(--color-primary-2);
  font-weight: 700;
}
.QuickLinksCard_ql__link__Hg6zh p {
  margin: 0;
  padding: 0;
}
.QuickLinksCard_ql__icon__JDxle {
  font-size: 2.2rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/AppHome/QuickLinksCard.module.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,mBAAA;EACA,wCAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;AADD;AAGC;EACC,UAAA;EACA,SAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;AADF;AAIC;EACC,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,qBAAA;AAFF;AAIE;EACC,mBAAA;AAFH;AAGG;EAFD;IAGE,mBAAA;EAAF;AACF;AAIC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAFF;AAIE;EACC,6BAAA;EACA,gBAAA;AAFH;AAKE;EACC,SAAA;EACA,UAAA;AAHH;AAOC;EACC,iBAAA;AALF","sourcesContent":["@import '../variables/breakpoints';\n\n.ql {\n\twidth: 100%;\n\tborder-radius: 2rem;\n\tbackground-color: var(--color-primary-3);\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tbox-sizing: border-box;\n\tpadding: 3.5rem 2rem;\n\n\t&__title {\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tfont-size: var(--default-font-size);\n\t\tfont-weight: 700;\n\t\tmargin-bottom: 3rem;\n\t}\n\n\t&__content {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-evenly;\n\t\tbox-sizing: border-box;\n\t\tmargin: 2rem 0 2rem 0;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 2rem;\n\t\t\t@media only screen and (max-width: $bp-medium) {\n\t\t\t\tmargin-bottom: 4rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__link {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-primary-2);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tp {\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t}\n\t}\n\n\t&__icon {\n\t\tfont-size: 2.2rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ql": `QuickLinksCard_ql__GQZNB`,
	"ql__title": `QuickLinksCard_ql__title__WMSzo`,
	"ql__content": `QuickLinksCard_ql__content__QKbvt`,
	"ql__link": `QuickLinksCard_ql__link__Hg6zh`,
	"ql__icon": `QuickLinksCard_ql__icon__JDxle`
};
export default ___CSS_LOADER_EXPORT___;
